import {Pipe, PipeTransform} from '@angular/core';
import {PersonStammMasterDetailEntryMeta} from "../../../core/personstamm-api";

@Pipe({
  name: 'tooltipPersonstammPipe'
})
export class TooltipPersonstammPipe implements PipeTransform {

  transform(entry: PersonStammMasterDetailEntryMeta): { person: string } {
    if (!entry) {
      return;
    }
    let name = entry.version.name;
    if (entry.version.vorname) {
      name = name + ' ' + entry.version.vorname;
    }
    return {person: name};
  }

}
